////////LIBRARY/////////
import React, { useEffect, useState, Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import { map, cloneDeep, isUndefined, isEmpty, isEqual, filter, find } from 'lodash'
import { useRouteMatch } from 'react-router'
import moment from 'moment'
import styled from 'styled-components'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import Button from '../../../components/Ui/Buttons'
import Modals from '../../../components/Modals'
import { languagesActionCreators, telecollectManagerActionCreators } from '../../../store/actions'
import { uriList } from '../../../routings/settings/RouteList'
import theme from '../../../theme/theme'
import StringFormatter from '../../../helpers/StringFormatter'
import UseDatePicker from '../../../hooks/UseDatePicker'
import DropdownCheckbox from '../../../components/DropdownCheckbox'
import useListSort from '../../../components/Table/hooks/UseListSort'
import {
	PageWrapperLinks,
	PageWrapperActions,
	PageWrapperActionPrevPage,
	PageWrapperActionReset,
	PageWrapperActionValidate,
	PageTitle,
	PageWrapperGrids,
	PageGridBorder,
	DatePickerFilterLabel,
} from '../../../theme/GlobalCss'
import TelecollectDetailSale from './TelecollectDetailSale'
import userPrivileges from '../../../constants/PrivilegesList'
import Tooltip from '../../../components/Tooltip/Tooltip'
/////////ASSETS/////////
import TelecollectDetailInfoPic from '../../../assets/icones/global/info-big-blue.svg'
import Calendar from '../../../assets/icones/global/calendar.svg'
import clearIcon from '../../../assets/icones/global/circle-green.svg'
import crossIcon from '../../../assets/icones/global/cross-circle-red.svg'
import ViewSaleIcon from '../../../assets/icones/global/view.svg'
import SwitchItemIcon from '../../../assets/icones/telecollectDetail/switch-button-icon.svg'
import favoriteIcon from '../../../assets/icones/telecollectDetail/favorite-icon.svg'
import TelecollectDetailStatusNoMatchIcon from '../../../assets/icones/telecollectDetail/cross-big-circle-red.svg'
import TelecollectDetailStatusMatchIcon from '../../../assets/icones/telecollectDetail/check-big-circle-green.svg'
import dropdownIcon from '../../../assets/icones/global/select-dropdown-black.svg'

//////STYLED//////
const TelecollectDetailWrapper = styled.div`
	position: relative;
	font-size: ${(props) => props.theme.font.fs};
`
const PageTitleTelecollect = styled(PageTitle)`
	margin-right: auto;
`
const TelecollectDetailHeaderWrapper = styled.div`
	min-width: max-content;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	border: 1px solid ${(props) => props.theme.colors.TabNav.border};
	padding: 13px;
	margin: 10px 0px;
	font-size: ${(props) => props.theme.font.fs};
`
const TelecollectDetailHeaderLabel = styled.div`
	display: flex;
	flex-direction: column;
	& :first-child {
		font-weight: bold;
	}
	justify-content: space-between;
`
const TelecollectDetailHeaderStatusWrapper = styled.div`
	display: flex;
	flex-direction: row;
	& > div {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin: 0px 10px;
	}
	margin-right: 52px;
	margin-left: auto;
`
const TelecollectDetailHeaderStatus = styled.div`
	background-color: ${(props) => props.colorCode};
	padding: 8px 16px;
	color: ${(props) => props.theme.colors.white};
	font-weight: bold;
	margin-left: 10px;
`
const TelecollectDetailHeaderSummaryWrapper = styled.div`
	display: flex;
	flex-direction: row;
	& > div {
		margin: 0px 5px;
	}
`
const TelecollectDetailHeaderSummary = styled.div`
	display: flex;
	flex-direction: column;
	text-align: center;
	font-weight: bold;
	color: white;
	background-color: ${(props) => props.colorCode};
	padding: 8px 0px;
	width: 137px;
`
const TelecollectDetailHeaderSummaryTotal = styled.div`
	width: 112px;
	display: flex;
	flex-direction: column;
	font-weight: bold;
	color: white;
	background-color: ${(props) => props.colorCode};
	padding: 5px;
	& > span:first-child {
		text-transform: uppercase;
		text-align: left;
	}
	& > div:last-child {
		text-align: right;
		font-size: ${(props) => props.theme.font.fxl};
		& > span:last-child {
			font-size: ${(props) => props.theme.font.fs};
			vertical-align: top;
		}
	}
`
const TelecollectDetailInfo = styled.div`
	background-color: #d7e9f5;
	border: 1px solid #c2dff2;
	border-radius: 5px;
	margin: 10px;
	padding: 12px;
	color: ${(props) => props.theme.colors.primary};
	display: flex;
	flex-direction: row;
	& img {
		width: 20px;
		display: inline-block;
		margin-right: 14px;
	}
`
const TelecollectDetailSubTitle = styled.span`
	padding: 11px;
	color: ${(props) => props.theme.colors.primary};
	font-weight: bold;
	display: block;
`
const DatePickerTelecollectDetailIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const TelecollectDetailActions = styled.div`
	padding: 10px;
	border-top: 1px solid ${(props) => props.theme.colors.TabNav.border};
	border-bottom: 1px solid ${(props) => props.theme.colors.TabNav.border};
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	min-height: 44px;
`
const TelecollectDetailActionsDate = styled.div`
	display: flex;
	flex-direction: row;
`
const TelecollectDetailActionsCheckboxWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	& input {
		margin-left: 8px;
	}
`
const TelecollectDetailItems = styled.div`
	display: flex;
	flex-direction: column;
	& > div {
		display: grid;
		grid-template-columns: 84px auto auto auto 15%;
	}
	min-height: 100px;
`
const TelecollectDetailItem = styled.div`
	border-radius: 28px;
	background-color: ${(props) => props.theme.colors.primary};
	margin: 5px 10px;
	padding: 12px;
	align-items: center;
	display: ${(props) => (props.visible ? 'flex ' : 'none !important')};
	flex-direction: row;
	justify-content: space-between;
	color: ${(props) => props.theme.colors.white};
`
const TelecollectDetailItemState = styled.div`
	background-image: url(${(props) => (props.paymentStatus ? `${clearIcon}` : `${crossIcon}`)});
	width: 16px;
	height: 16px;
	background-repeat: no-repeat;
	background-position: center;
`
const TelecollectDetailItemDate = styled.div`
	width: 70px;
	font-weight: bold;
	text-align: center;
	& > span {
		display: block;
	}
`
const TelecollectDetailItemMode = styled.div`
	font-weight: bold;
	text-align: center;
	min-width: 100px;
	& > span {
		display: block;
	}
`
const TelecollectDetailItemPrice = styled.div`
	font-size: ${(props) => props.theme.font.fxl};
	font-weight: bold;
	& > span:last-child {
		font-size: ${(props) => props.theme.font.fs};
		vertical-align: top;
	}
`
const TelecollectDetailItemTotal = styled.div`
	text-align: center;
	& > span {
		display: block;
	}
	& > span:last-child {
		font-weight: bold;
		color: ${(props) => (props.comparisonSuccess ? '#00FF33' : props.theme.colors.white)};
	}
	& > span:last-child::after {
		content: '';
		display: ${(props) => (props.comparisonSuccess ? 'inline-block' : 'none')};
		width: 16px;
		height: 16px;
		background-image: url(${favoriteIcon});
		margin-left: 3px;
		vertical-align: middle;
	}
`
const TelecollectDetailItemActions = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`

const TelecollectDetailItemAction = styled.div`
	width: 32px;
	height: 32px;
	border-radius: 16px;
	background-color: ${(props) => props.theme.colors.white};
	background-image: url(${(props) => props.icon});
	background-repeat: no-repeat;
	background-position: center;
	margin: 0px 5px;
	transform: ${(props) => (props.reverse ? 'scale(-1)' : 'scale(1)')};
	cursor: pointer;
`
const TelecollectDetailStatusSummaryWrapper = styled.div`
	padding: 10px 10px 20px 10px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	& > div:last-child {
		display: flex;
		flex-direction: row;
		& > * {
			margin: 0px 5px;
		}
	}
	& > div:first-child {
		display: flex;
		flex-direction: row;
		align-items: center;
		& > img {
			margin-left: 10px;
		}
	}
`
const TelecollectDetailActionsSort = styled.div`
	color: ${(props) => props.theme.colors.primary};
	& > img {
		width: 11px;
		height: 6px;
		margin-left: 4px;
		vertical-align: middle;
	}
	cursor: pointer;
	position: relative;
`
const TelecollectDetailActionsSortActions = styled.div`
	display: ${(props) => (props.visible ? 'flex' : 'none')};
	padding: 10px 0px;
	flex-direction: column;
	& > div {
		line-height: 32px;
		padding: 0px 32px;
		color: #242424;
	}
	background-color: ${(props) => props.theme.colors.white};
	position: absolute;
	z-index: 5;
	width: 267px;
	box-shadow: 0px 0px 6px #00000029;
	top: 25px;
`
const TelecollectDetailItemsCustom = styled(TelecollectDetailItems)`
	position: relative;
	min-height: 100px;
	> div:first-child {
		display: flex;
		flex-direction: column;
		position: absolute;
		right: -46px;
		width: 45px;
		& > img {
			filter: grayscale(1);
			margin: 7px;
		}
		& > img:last-child {
			transform: scaleX(-1);
		}
	}
	& > div {
		display: flex;
	}
`
const PageWrapperGridsCustom = styled(PageWrapperGrids)`
	grid-template-columns: 1fr 15px 1fr;
	grid-column-gap: 15px;
`
//////STYLED//////

const TelecollectDetail = () => {
	const match = useRouteMatch()

	let history = useHistory()

	const [showSaleModal, setShowSaleModal] = useState(false)

	const [row, setRow] = useState()

	const [
		dateTelecollectDetailExcludedShowModal,
		dateTelecollectDetailExcludedOpenDateModalHandler,
		dateTelecollectDetailExcludedRenderModal,
		dateTelecollectDetailExcludedStateDate,
	] = UseDatePicker({
		defaultDateStart: moment().subtract(2, 'weeks').toDate(),
		defaultDateEnd: moment().toDate(),
		insideModal: false,
	})

	const {
		user,
		translations,
		telecollectManager,
		userKioskPerimeter,
		telecollectDetailHeader,
		telecollectDetailItemsExcluded,
		telecollectDetailItemsExcludedFilters,
		telecollectDetailItemsIncluded,
		telecollectDetailItemsIncludedFilters,
	} = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			telecollectManager: state.telecollectManager,
			telecollectDetailHeader: state.telecollectManager.telecollectDetail,
			telecollectDetailItemsExcluded: state.telecollectManager.telecollectDetailItems.excluded,
			telecollectDetailItemsExcludedFilters: state.telecollectManager.telecollectDetailItems.header.excluded || {},
			telecollectDetailItemsIncluded: state.telecollectManager.telecollectDetailItems.included,
			telecollectDetailItemsIncludedFilters: state.telecollectManager.telecollectDetailItems.header.included || {},
			userKioskPerimeter: state.user.identity.kioskSelected,
		}),
		shallowEqual
	)

	const actionsTelecollectManager = bindActionCreators(telecollectManagerActionCreators, useDispatch())
	const actionsLanguages = bindActionCreators(languagesActionCreators, useDispatch())

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	const sortableActionsConfig = [
		{ label: translations['common__text__dateESC'], sortColumnName: 'dateCreated', sortDir: 1 },
		{ label: translations['common__text__dateDESC'], sortColumnName: 'dateCreated', sortDir: 0 },
		{ label: translations['common__text__amountESC'], sortColumnName: 'transactionTotalAmoutTTC', sortDir: 1 },
		{ label: translations['common__text__amountDESC'], sortColumnName: 'transactionTotalAmoutTTC', sortDir: 0 },
	]

	// Excluded sales hooks
	const [filtersExcluded, setFiltersExcluded] = useState({})
	const [prevFilterExcluded, setPrevFilterExcluded] = useState({})
	const [inputDataExcluded, setInputDataExcluded] = useState([])
	const [baseDataExcluded, setBaseDataExcluded] = useState([])

	const [tableDataExcluded, triggerExcluded, setTriggerExcluded, setTableDataExcluded, sortDirectionExcluded, setSortDirectionExcluded] =
		useListSort(
			[
				{ dataHook: 'transactionTotalAmoutTTC', headerName: 'transactionTotalAmoutTTC', sortable: true },
				{ dataHook: 'dateCreated', headerName: 'dateCreated', sortable: true },
			],
			inputDataExcluded
		)

	const [toggleActionsSortableExcluded, setToggleActionsSortableExcluded] = useState(false)

	// Included sales hooks
	const [filtersIncluded, setFiltersIncluded] = useState({})
	const [prevFilterIncluded, setPrevFilterIncluded] = useState({})
	const [inputDataIncluded, setInputDataIncluded] = useState([])
	const [baseDataIncluded, setBaseDataIncluded] = useState([])

	const [tableDataIncluded, triggerIncluded, setTriggerIncluded, setTableDataIncluded, sortDirectionIncluded, setSortDirectionIncluded] =
		useListSort(
			[
				{ dataHook: 'transactionTotalAmoutTTC', headerName: 'transactionTotalAmoutTTC', sortable: true },
				{ dataHook: 'dateCreated', headerName: 'dateCreated', sortable: true },
			],
			inputDataIncluded
		)

	const [toggleActionsSortableIncluded, setToggleActionsSortableIncluded] = useState(false)

	// Current telecollect status hooks
	const [currentSalesValidated, setCurrentSalesValidated] = useState()
	const [currentSalesCancelled, setCurrentSalesCancelled] = useState()
	const [currentTotal, setCurrentTotal] = useState(0)
	const [isTotalOk, setIsTotalOk] = useState(false)
	const [isSalesNumberOk, setIsSalesNumberOk] = useState(false)

	// Can validate form
	const [canValidate, setCanValidate] = useState(false)

	///////////////////////////////// HANDLE ///////////////////////////////////////

	//////////////////////////////
	// INCLUDED SALES FUNCTIONS //
	//////////////////////////////
	const handleDropdownIncluded = (id, isChecked, target) => {
		const filtersCP = cloneDeep(filtersIncluded)
		filtersCP.filtersSelection[target].filterElements = map(filtersCP.filtersSelection[target].filterElements, (elem) => {
			if (elem.id === id) {
				elem.active = !isChecked
			}
			return elem
		})

		if (
			!isEqual(filtersCP.filtersSelection[target].filterElements, telecollectDetailItemsIncludedFilters.filtersSelection[target].filterElements)
		) {
			filtersCP.filtersSelection[target].updated = true
		}
		setFiltersIncluded(filtersCP)
	}

	const handleFilterItemsSendIncluded = (filters) => {
		return {
			withFilters: true,
			userKioskScope: {
				kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			},
			...filters,
		}
	}

	const handleSubmitIncluded = () => {
		if (isEqual(filtersIncluded, prevFilterIncluded)) return // guard to call if no change

		setPrevFilterIncluded(filtersIncluded)
		actionsTelecollectManager.getDetailItems(match.params.id, handleFilterItemsSendIncluded(filtersIncluded), 'included')
	}

	const removeSaleToTelecollect = (includedSale) => {
		let excludedSales = cloneDeep(inputDataExcluded)
		excludedSales.push(includedSale)
		setInputDataExcluded(excludedSales)

		let includedSales = cloneDeep(inputDataIncluded)
		includedSales = filter(includedSales, (o) => o.id !== includedSale.id)
		setInputDataIncluded(includedSales)
	}

	// to readjust current telecollect, and check everything is ok
	const handleCurrentTelecollectState = () => {
		let currentTotal = 0
		let nb_cancelled_sales = 0
		let nb_validated_sales = 0

		map(inputDataIncluded, (elem) => {
			if (elem.paymentStatus.id === 3) {
				//currentTotal += elem.transactionTotalAmoutTTC
				currentTotal += parseFloat(elem.transactionTotalAmoutTTC.replace(',', '.'))
				nb_validated_sales++
			}
			if (elem.paymentStatus.id === 1 || elem.paymentStatus.id === 2) nb_cancelled_sales++
		})

		currentTotal = parseFloat(currentTotal.toFixed(2))

		setCurrentTotal(currentTotal)
		setCurrentSalesCancelled(nb_cancelled_sales)
		setCurrentSalesValidated(nb_validated_sales)

		// Checking if telecollect can be validated
		//setIsTotalOk(currentTotal === telecollectDetailHeader.totalAmountTTC)
		if (!isUndefined(telecollectDetailHeader.totalAmountTTC))
			setIsTotalOk(currentTotal === parseFloat(telecollectDetailHeader.totalAmountTTC.replace(',', '.')))
		setIsSalesNumberOk(nb_cancelled_sales === telecollectDetailHeader.cancelQty && nb_validated_sales === telecollectDetailHeader.buyQty)
	}

	const handleSortTableHeaderIncluded = (headerName) => {
		setTriggerIncluded({
			data: headerName,
			trigger: triggerIncluded + 1,
		})
	}

	const handleSaleModal = (row) => {
		setRow(row)
		setShowSaleModal((prevState) => !prevState)
	}

	const handleFilterHeaderPerimeter = (_additionalParams) => {
		return { kiosksInLocalScope: map(user.identity.kioskSelected, 'id') }
	}

	const handleSubmitTelecollect = () => {
		const bodyMsg = {
			userKioskScope: { kiosksInLocalScope: map(user.identity.kioskSelected, 'id') },
			salesOrdersIds: map(inputDataIncluded, 'id'),
		}
		actionsTelecollectManager.setTelecollectComparison(match.params.id, bodyMsg)
	}

	const handleSortTableHeaderExcluded = (headerName) => {
		setTriggerExcluded({
			data: headerName,
			trigger: triggerExcluded + 1,
		})
	}

	//////////////////////////////
	// EXCLUDED SALES FUNCTIONS //
	//////////////////////////////
	const handleFilterItemsSendExcluded = (filters) => {
		return {
			withFilters: true,
			datesRange: {
				// Dummy dates
				dateStart: dateTelecollectDetailExcludedStateDate.date.startDate,
				dateEnd: dateTelecollectDetailExcludedStateDate.date.endDate,
			},
			userKioskScope: {
				kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			},
			...filters,
		}
	}

	const handleRedirect = () => {
		history.push(`${uriList.sales}${uriList.telecollectManager}`)
	}

	const handleDropdownExcluded = (id, isChecked, target) => {
		let filtersCP = cloneDeep(filtersExcluded)

		filtersCP.filtersSelection[target].filterElements = map(filtersCP.filtersSelection[target].filterElements, (elem) => {
			if (elem.id === id) {
				elem.active = !isChecked
			}
			return elem
		})

		if (
			!isEqual(filtersCP.filtersSelection[target].filterElements, telecollectDetailItemsExcludedFilters.filtersSelection[target].filterElements)
		) {
			filtersCP.filtersSelection[target].updated = true
		}
		setFiltersExcluded(filtersCP)
	}

	const handleSubmitExcluded = () => {
		if (isEqual(filtersExcluded, prevFilterExcluded)) return // guard to call if no change

		setPrevFilterExcluded(filtersExcluded)
		actionsTelecollectManager.getDetailItems(match.params.id, handleFilterItemsSendExcluded(filtersExcluded), 'excluded')
	}

	const handleCheckboxExcluded = (e) => {
		let flt = handleFilterItemsSendExcluded(filtersExcluded)
		flt.filtersSelection.withNotSuggest = e.target.checked
		actionsTelecollectManager.getDetailItems(match.params.id, flt, 'excluded')
	}

	const addSaleToTelecollect = (excludedSale) => {
		let includedSales = cloneDeep(inputDataIncluded)
		includedSales.push(excludedSale)
		setInputDataIncluded(includedSales)

		let excludedSales = cloneDeep(inputDataExcluded)
		excludedSales = filter(excludedSales, (o) => o.id !== excludedSale.id)
		setInputDataExcluded(excludedSales)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (isUndefined(user)) return
		actionsTelecollectManager.getDetailHeader(match.params.id, handleFilterHeaderPerimeter())
		const defaultParams = {
			withFilters: false,
			datesRange: {
				// Dummy dates
				dateStart: moment().subtract(2, 'weeks').toDate(),
				dateEnd: moment().toDate(),
			},
			userKioskScope: {
				kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			},
		}
		actionsTelecollectManager.getDetailItems(match.params.id, defaultParams)

		return function cleanUp() {
			actionsTelecollectManager.resetTelecollectItems()
		}
	}, [])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks)) {
			const defaultParams = {
				withFilters: false,
				datesRange: {
					// Dummy dates
					dateStart: moment().subtract(2, 'weeks').toDate(),
					dateEnd: moment().toDate(),
				},
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			}
			actionsTelecollectManager.getDetailItems(match.params.id, defaultParams)
		}
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	useEffect(() => {
		let dataExcluded = cloneDeep(inputDataExcluded)
		if (isTotalOk && isSalesNumberOk) {
			// If we load compared telecollect, we block if data has not changed
			//setInputDataExcluded([])

			map(dataExcluded, (elem) => {
				elem.visible = false
			})

			if (
				telecollectDetailHeader.paymentCollectionStatus.translationKey === 'ref__status__paymentCollection_done' &&
				telecollectDetailHeader.comparisonStatus.translationKey === 'ref__status__comparison_compared' &&
				isEqual(baseDataIncluded, inputDataIncluded)
			) {
				setCanValidate(false)
			} else {
				setCanValidate(true)
			}
		} else {
			setCanValidate(false)

			map(dataExcluded, (elem) => {
				elem.visible = true
			})
		}
		setInputDataExcluded(dataExcluded)
	}, [isTotalOk, isSalesNumberOk])

	useEffect(() => {
		const filtersCp = cloneDeep(telecollectDetailItemsExcludedFilters)

		setFiltersExcluded(filtersCp)
		setPrevFilterExcluded(filtersCp)
	}, [telecollectDetailItemsExcludedFilters])

	useEffect(() => {
		if (dateTelecollectDetailExcludedStateDate.showModal) {
			actionsTelecollectManager.getDetailItems(match.params.id, handleFilterItemsSendExcluded(filtersExcluded), 'excluded')
		}
	}, [dateTelecollectDetailExcludedShowModal])

	useEffect(() => {
		setInputDataExcluded(telecollectDetailItemsExcluded)
		// Set base data => for reset
		if (isEmpty(baseDataExcluded)) setBaseDataExcluded(telecollectDetailItemsExcluded)
	}, [telecollectDetailItemsExcluded])

	useEffect(() => {
		if (!isUndefined(sortDirectionExcluded)) {
			setSortDirectionExcluded(1)
			setTableDataExcluded(cloneDeep(inputDataExcluded))
			handleSortTableHeaderExcluded('transactionTotalAmoutTTC')
		} else {
			setTableDataExcluded(cloneDeep(inputDataExcluded))
		}
	}, [inputDataExcluded])

	useEffect(() => {
		const filtersCp = cloneDeep(telecollectDetailItemsIncludedFilters)

		setFiltersIncluded(filtersCp)
		setPrevFilterIncluded(filtersCp)
	}, [telecollectDetailItemsIncludedFilters])

	useEffect(() => {
		setInputDataIncluded(telecollectDetailItemsIncluded)
		// Set base data => for reset
		if (isEmpty(baseDataIncluded)) setBaseDataIncluded(telecollectDetailItemsIncluded)
	}, [telecollectDetailItemsIncluded])

	// Calculating current validated/cancelled sales and total
	useEffect(() => {
		handleCurrentTelecollectState()

		if (!isUndefined(sortDirectionIncluded)) {
			setSortDirectionIncluded(1)
			setTableDataIncluded(cloneDeep(inputDataIncluded))
			handleSortTableHeaderIncluded('transactionTotalAmoutTTC')
		} else {
			setTableDataIncluded(cloneDeep(inputDataIncluded))
		}
	}, [inputDataIncluded])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			<Modals
				closeModalHandler={handleSaleModal}
				showModal={showSaleModal}
				minWidth={1200}
				title={translations['modal__paymentCollectionManagement__admin__detail__salesOrders__title']}
				icon={true}
			>
				<TelecollectDetailSale row={row} idTelecollect={match.params.id} />
			</Modals>
			{dateTelecollectDetailExcludedRenderModal()}
			<TelecollectDetailWrapper>
				<PageWrapperLinks>
					<Button
						goBack
						weight="bold"
						//actionHandler={ () => {history.push(`${uriList.sales}${uriList.telecollectManager}`)} }
						actionHandler={() => handleRedirect()}
						text={translations['common__text__previousPage']}
					/>
				</PageWrapperLinks>
				<PageWrapperActions>
					<Tooltip translationsKey={'tooltip__admin__global__save'} tooltipId={'paymentCollectionDetailSubmit'}>
						<PageWrapperActionValidate
							type="submit"
							unlocked={canValidate}
							onClick={() => {
								if (canValidate) handleSubmitTelecollect()
							}}
						/>
					</Tooltip>
					<Tooltip translationsKey={'tooltip__admin__global__cancelClose'} tooltipId={'paymentCollectionDetailClose'} position={'left'}>
						<PageWrapperActionPrevPage onClick={() => history.push(`${uriList.sales}${uriList.telecollectManager}`)} />
					</Tooltip>
					<Tooltip translationsKey={'tooltip__admin__global__reset'} tooltipId={'paymentCollectionDetailReset'} position={'left'}>
						<PageWrapperActionReset
							onClick={() => {
								setInputDataExcluded(baseDataExcluded)
								setInputDataIncluded(baseDataIncluded)
							}}
						/>
					</Tooltip>
					{telecollectDetailHeader?.number && (
						<PageTitleTelecollect>
							{StringFormatter.ResponseMessageParser(translations['page__paymentCollectionManagement__detail__tab'], [
								telecollectDetailHeader.number,
							])}
						</PageTitleTelecollect>
					)}
				</PageWrapperActions>
				{!isEmpty(telecollectDetailHeader) && translations && (
					<TelecollectDetailHeaderWrapper>
						<TelecollectDetailHeaderLabel>
							<span>
								{translations['page__paymentCollectionManagement__detail__header__number']}
								{telecollectDetailHeader.number} -{' '}
								{translations['page__paymentCollectionManagement__detail__header__comparisonStatus']}
							</span>
							<span>
								{translations['page__paymentCollectionManagement__detail__header__dateCreated']}{' '}
								{moment(telecollectDetailHeader.dateCreated).format('DD/MM/YYYY HH:mm')}
							</span>
						</TelecollectDetailHeaderLabel>
						<TelecollectDetailHeaderStatusWrapper>
							<div>
								<span>{translations['page__paymentCollectionManagement__detail__header__status']} :</span>
								<TelecollectDetailHeaderStatus colorCode={telecollectDetailHeader.paymentCollectionStatus.colorCode}>
									{translations[telecollectDetailHeader.paymentCollectionStatus.translationKey]}
								</TelecollectDetailHeaderStatus>
							</div>
							<div>
								<span>{translations['page__paymentCollectionManagement__detail__header__comparisonStatus']} :</span>
								<TelecollectDetailHeaderStatus colorCode={telecollectDetailHeader.comparisonStatus.colorCode}>
									{translations[telecollectDetailHeader.comparisonStatus.translationKey]}
								</TelecollectDetailHeaderStatus>
							</div>
						</TelecollectDetailHeaderStatusWrapper>
						<TelecollectDetailHeaderSummaryWrapper>
							<TelecollectDetailHeaderSummary colorCode={theme.colors.primary}>
								<span>{translations['page__paymentCollectionManagement__detail__header__buyQty_cancelQty']}</span>
								<span>
									{telecollectDetailHeader.buyQty} - {telecollectDetailHeader.cancelQty}
								</span>
							</TelecollectDetailHeaderSummary>
							<TelecollectDetailHeaderSummaryTotal colorCode={theme.colors.primary}>
								<span>{translations['page__paymentCollectionManagement__detail__header__paymentCollectionAmountTTC']}</span>
								<div>
									<span>
										{telecollectDetailHeader.totalAmountTTC}
										{telecollectDetailHeader.currency.symbol}
									</span>
									<span>{translations['common__text__TTC']}</span>
								</div>
							</TelecollectDetailHeaderSummaryTotal>
						</TelecollectDetailHeaderSummaryWrapper>
					</TelecollectDetailHeaderWrapper>
				)}
				{!isEmpty(telecollectDetailHeader) && translations && (
					<PageWrapperGridsCustom grids={2}>
						<PageGridBorder>
							<TelecollectDetailInfo>
								<img src={TelecollectDetailInfoPic} />
								<span>{translations['page__paymentCollectionManagement__detail__salesOrderNotInclued__infoMessage']}</span>
							</TelecollectDetailInfo>
							<TelecollectDetailSubTitle>
								{translations['page__paymentCollectionManagement__detail__salesOrderNotInclued__title']}
							</TelecollectDetailSubTitle>
							<TelecollectDetailActions>
								<TelecollectDetailActionsSort onClick={() => setToggleActionsSortableExcluded(!toggleActionsSortableExcluded)}>
									<span>{translations['common__text__sort']}</span>
									<img src={dropdownIcon} />
									<TelecollectDetailActionsSortActions visible={toggleActionsSortableExcluded}>
										{map(sortableActionsConfig, (cfg) => (
											<div
												onClick={() => {
													handleSortTableHeaderExcluded(cfg.sortColumnName)
													setSortDirectionExcluded(cfg.sortDir)
													setToggleActionsSortableExcluded(false)
												}}
											>
												{cfg.label}
											</div>
										))}
									</TelecollectDetailActionsSortActions>
								</TelecollectDetailActionsSort>
								<TelecollectDetailActionsDate>
									<label style={{ color: theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
										{translations['page__paymentCollectionManagement__admin__header__datePicker__paymentCollectionDate']} :
									</label>
									<DatePickerTelecollectDetailIcon onClick={dateTelecollectDetailExcludedOpenDateModalHandler} />
									<DatePickerFilterLabel>
										<span>
											{translations['page__global__admin__header_datePicker_from']}{' '}
											{isEqual(dateTelecollectDetailExcludedStateDate.date.startDate, {})
												? moment(new Date()).subtract(2, 'months').format('DD/MM/YYYY HH:mm')
												: moment(dateTelecollectDetailExcludedStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
										</span>
										<span>
											{translations['page__global__admin__header_datePicker_to']}{' '}
											{isEqual(dateTelecollectDetailExcludedStateDate.date.endDate, {})
												? moment(new Date()).format('DD/MM/YYYY HH:mm')
												: moment(dateTelecollectDetailExcludedStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
										</span>
									</DatePickerFilterLabel>
								</TelecollectDetailActionsDate>
								<DropdownCheckbox
									title={translations['page__paymentCollectionManagement__detail__header__buyQty_cancelQty']}
									data={filtersExcluded.filtersSelection?.paymentStatus.filterElements || []}
									translations={translations}
									paperTopPosition={'40'}
									dropColor={'blueColor'}
									selectActionsHandler={handleDropdownExcluded}
									submitOnClose={handleSubmitExcluded}
									target={'paymentStatus'}
									toTranslate
								/>
								{
									// Hide this checkbox for release, will be obsolete
									/*<TelecollectDetailActionsCheckboxWrapper>
                                <label for="withNotSuggest"> {translations['page__paymentCollectionManagement__detail__salesOrderNotInclued__header__filter__salesNotSuggest']}</label>
                                <input type="checkbox" id="withNotSuggest" onClick={(e) => handleCheckboxExcluded(e)}/>
                            </TelecollectDetailActionsCheckboxWrapper>*/
								}
							</TelecollectDetailActions>
							{!isUndefined(tableDataExcluded) && translations && (
								<TelecollectDetailItemsCustom>
									<div>
										<img src={SwitchItemIcon} />
										<img src={SwitchItemIcon} />
									</div>
									{map(tableDataExcluded, (elem) => {
										const new_total =
											elem.paymentStatus.id === 3
												? parseFloat(parseFloat(elem.transactionTotalAmoutTTC.replace(',', '.')).toFixed(2)) + currentTotal
												: parseFloat(elem.transactionTotalAmoutTTC.replace(',', '.'))

										return (
											<TelecollectDetailItem visible={elem.visible}>
												<TelecollectDetailItemState paymentStatus={elem.paymentStatus.id === 3} />
												<TelecollectDetailItemDate>
													<span>{moment(elem.dateCreated).format('DD/MM/YYYY')}</span>
													<span>{moment(elem.dateCreated).format('HH:MM')}</span>
												</TelecollectDetailItemDate>
												<TelecollectDetailItemMode>
													<span>{translations[elem.paymentStatus.translationKey]}</span>
													<span>{translations[elem.paymentType.translationKey]}</span>
												</TelecollectDetailItemMode>
												<TelecollectDetailItemPrice>
													<span>
														{elem.transactionTotalAmoutTTC}
														{elem.currency.symbol}
													</span>
													<span>{translations['common__text__TTC']}</span>
												</TelecollectDetailItemPrice>
												{
													<TelecollectDetailItemTotal
														comparisonSuccess={
															new_total === parseFloat(telecollectDetailHeader.totalAmountTTC.replace(',', '.'))
														}
													>
														<span>
															{
																translations[
																	'page__paymentCollectionManagement__detail__salesOrderNotInclued__header__newTotal'
																]
															}{' '}
															:
														</span>
														<span>
															{new_total.toFixed(2).replace('.', ',')}
															{elem.currency.symbol}
														</span>
													</TelecollectDetailItemTotal>
												}
												<TelecollectDetailItemActions>
													<Tooltip
														translationsKey={'tooltip__admin__global__action__salesHistory_detail'}
														tooltipId={'paymentCollectionDetailSeeSales'}
													>
														<TelecollectDetailItemAction icon={ViewSaleIcon} onClick={() => handleSaleModal(elem)} />
													</Tooltip>
													{!isUndefined(
														find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[8])
													) && (
														<Tooltip
															translationsKey={'tooltip__admin__paymentCollectionDetail__include'}
															tooltipId={'paymentCollectionDetailInclude'}
														>
															<TelecollectDetailItemAction
																icon={SwitchItemIcon}
																onClick={() => addSaleToTelecollect(elem)}
															/>
														</Tooltip>
													)}
												</TelecollectDetailItemActions>
											</TelecollectDetailItem>
										)
									})}
								</TelecollectDetailItemsCustom>
							)}
						</PageGridBorder>
						<div></div>
						<PageGridBorder>
							<TelecollectDetailStatusSummaryWrapper>
								<div>
									<span>{translations['page__paymentCollectionManagement__detail__header__comparisonisPossible_text']} :</span>
									<img src={isTotalOk && isSalesNumberOk ? TelecollectDetailStatusMatchIcon : TelecollectDetailStatusNoMatchIcon} />
								</div>
								<div>
									<TelecollectDetailHeaderSummary colorCode={isSalesNumberOk ? theme.colors.validation : theme.colors.error}>
										<span>{translations['page__paymentCollectionManagement__detail__header__buyQty_cancelQty']}</span>
										<span>
											{currentSalesValidated} - {currentSalesCancelled}
										</span>
									</TelecollectDetailHeaderSummary>
									<TelecollectDetailHeaderSummaryTotal colorCode={isTotalOk ? theme.colors.validation : theme.colors.error}>
										<span>{translations['page__paymentCollectionManagement__detail__header__paymentCollectionAmountTTC']}</span>
										<div>
											<span>
												{currentTotal.toFixed(2).replace('.', ',')}
												{telecollectDetailHeader.currency.symbol}
											</span>
											<span>{translations['common__text__TTC']}</span>
										</div>
									</TelecollectDetailHeaderSummaryTotal>
								</div>
							</TelecollectDetailStatusSummaryWrapper>
							<TelecollectDetailSubTitle>
								{translations['page__paymentCollectionManagement__detail__salesOrderInclued__text__salesIncluded']}
							</TelecollectDetailSubTitle>
							<TelecollectDetailActions>
								<TelecollectDetailActionsSort onClick={() => setToggleActionsSortableIncluded(!toggleActionsSortableIncluded)}>
									<span>Trier</span>
									<img src={dropdownIcon} />
									<TelecollectDetailActionsSortActions visible={toggleActionsSortableIncluded}>
										{map(sortableActionsConfig, (cfg) => (
											<div
												onClick={() => {
													handleSortTableHeaderIncluded(cfg.sortColumnName)
													setSortDirectionIncluded(cfg.sortDir)
													setToggleActionsSortableIncluded(false)
												}}
											>
												{cfg.label}
											</div>
										))}
									</TelecollectDetailActionsSortActions>
								</TelecollectDetailActionsSort>
								<DropdownCheckbox
									title={translations['page__paymentCollectionManagement__detail__header__buyQty_cancelQty']}
									data={filtersIncluded.filtersSelection?.paymentStatus.filterElements || []}
									translations={translations}
									paperTopPosition={'40'}
									dropColor={'blueColor'}
									selectActionsHandler={handleDropdownIncluded}
									submitOnClose={handleSubmitIncluded}
									target={'paymentStatus'}
									toTranslate
								/>
							</TelecollectDetailActions>
							{!isUndefined(tableDataIncluded) && translations && (
								<TelecollectDetailItems>
									{map(tableDataIncluded, (elem) => {
										return (
											<TelecollectDetailItem visible={elem.visible}>
												<TelecollectDetailItemActions>
													{!isUndefined(
														find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[8])
													) && (
														<Tooltip
															translationsKey={'tooltip__admin__paymentCollectionDetail__exclude'}
															tooltipId={'paymentCollectionDetailInclude'}
														>
															<TelecollectDetailItemAction
																icon={SwitchItemIcon}
																onClick={() => removeSaleToTelecollect(elem)}
																reverse
															/>
														</Tooltip>
													)}
													<Tooltip
														translationsKey={'tooltip__admin__global__action__salesHistory_detail'}
														tooltipId={'paymentCollectionDetailSeeSales'}
													>
														<TelecollectDetailItemAction icon={ViewSaleIcon} onClick={() => handleSaleModal(elem)} />
													</Tooltip>
												</TelecollectDetailItemActions>
												<TelecollectDetailItemState paymentStatus={elem.paymentStatus.id === 3} />
												<TelecollectDetailItemDate>
													<span>{moment(elem.dateCreated).format('DD/MM/YYYY')}</span>
													<span>{moment(elem.dateCreated).format('HH:MM')}</span>
												</TelecollectDetailItemDate>
												<TelecollectDetailItemMode>
													<span>{translations[elem.paymentStatus.translationKey]}</span>
													<span>{translations[elem.paymentType.translationKey]}</span>
												</TelecollectDetailItemMode>
												<TelecollectDetailItemPrice>
													<span>
														{elem.transactionTotalAmoutTTC}
														{elem.currency.symbol}
													</span>
													<span>{translations['common__text__TTC']}</span>
												</TelecollectDetailItemPrice>
											</TelecollectDetailItem>
										)
									})}
								</TelecollectDetailItems>
							)}
						</PageGridBorder>
					</PageWrapperGridsCustom>
				)}
			</TelecollectDetailWrapper>
		</Fragment>
	)
}

TelecollectDetail.propTypes = {}

TelecollectDetail.defaultPropTypes = {}

export default TelecollectDetail
